import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";

const Stat = ({ label, value, testid }) => (
  <div className="bg-white border border-[#E5E1D8] rounded-2xl p-5">
    <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#748E63]">{label}</p>
    <p className="font-display text-4xl mt-2" data-testid={testid}>{value ?? "—"}</p>
  </div>
);

export default function StatsCards({ stats }) {
  return (
    <div className="space-y-4" data-testid="admin-stats">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat label="Iscritte totali" value={stats?.total} testid="stat-total" />
        <Stat label="Ultimi 7 giorni" value={stats?.last7} testid="stat-last7" />
        <Stat label="Oggi" value={stats?.today} testid="stat-today" />
        <Stat label="Sequenza completata" value={stats?.sequence_completed} testid="stat-completed" />
      </div>
      <div className="bg-white border border-[#E5E1D8] rounded-2xl p-5">
        <p className="text-sm font-semibold mb-3">Iscrizioni ultimi 14 giorni</p>
        <div className="h-40">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={stats?.daily || []}>
              <XAxis dataKey="day" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip cursor={{ fill: "#F9F7F3" }} formatter={(v) => [v, "iscritte"]} />
              <Bar dataKey="count" fill="#C05746" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
